<template>
  <div style="display: flex; gap: 5px; width: 100%; justify-content: flex-end; margin-top: 10px">
    <el-button
      v-if="props.disabled"
      type="primary"
      size="default"
      :icon="IconAdd"
      @click="handleClickAdd"
      >Nuevo</el-button
    >
    <el-button
      v-if="!props.disabled"
      type="primary"
      size="default"
      :icon="IconCheck"
      @click="handleClickSave"
      >Guardar</el-button
    >
    <el-button
      v-if="!props.disabled"
      type="primary"
      size="default"
      :icon="IconCancel"
      @click="handleClickCancel"
      >Cancelar</el-button
    >
  </div>
</template>

<script setup>
import IconAdd from '~icons/mdi/add';
import IconCancel from '~icons/mdi/cancel';
import IconCheck from '~icons/mdi/check';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['add', 'save', 'cancel']);

const handleClickAdd = () => {
  emit('add');
};

const handleClickSave = () => {
  emit('save');
};

const handleClickCancel = () => {
  emit('cancel');
};
</script>

<style scoped></style>
